import React, { useEffect } from "react";
import { ArrowLeft, ArrowRight, CalendarIcon } from "../../../modules/default-svg";
import styles from "../timesheet.module.scss";
import moment from "moment";
import $ from "jquery";

const WeekSelector = ({ currentWeek, onWeekChange, showWeekend = false }) => {
  const getFormattedDateRange = () => {
    if (!currentWeek) return '';
    
    const startDate = moment(currentWeek.startDate).startOf('day');
    const endDate = showWeekend 
      ? moment(currentWeek.endDate).startOf('day')
      : moment(currentWeek.startDate).add(4, 'days').startOf('day');
    
    return `${startDate.format("DD MMM YYYY")} – ${endDate.format("DD MMM YYYY")}`;
  };

  useEffect(() => {
    if (!currentWeek) return;

    const handleDateChange = (start, end) => {
      const weekStart = moment(start).startOf('isoWeek');
      const weekEnd = moment(start).endOf('isoWeek');
      
      const newWeek = {
        year: weekEnd.year(),
        week: weekStart.isoWeek(),
        startDate: weekStart.toDate(),
        endDate: weekEnd.toDate(),
      };
      onWeekChange(newWeek);
    };

    const startDate = moment(currentWeek.startDate).startOf('day');
    const endDate = showWeekend 
      ? moment(currentWeek.endDate).startOf('day')
      : moment(currentWeek.startDate).add(4, 'days').startOf('day');

    // Get the end of the current week as max date
    const currentWeekEnd = moment().endOf('isoWeek').endOf('day');

    $("input[name='timesheetDatetimes']").daterangepicker(
      {
        startDate: startDate,
        endDate: endDate,
        autoApply: true,
        maxDate: currentWeekEnd,
        locale: {
          format: 'DD MMM YYYY',
          firstDay: 1
        },
        linkedCalendars: false,
        showCustomRangeLabel: false,
      },
      handleDateChange
    );

    return () => {
      if ($("input[name='timesheetDatetimes']").data('daterangepicker')) {
        $("input[name='timesheetDatetimes']").daterangepicker("destroy");
      }
    };
  }, [currentWeek, showWeekend, onWeekChange]);

  const handlePrevious = () => {
    if (!currentWeek) return;
    const prevWeekStart = moment(currentWeek.startDate).subtract(7, "days").startOf('isoWeek');
    const prevWeekEnd = prevWeekStart.clone().endOf('isoWeek');
    const newWeek = {
      year: prevWeekEnd.year(),
      week: prevWeekStart.isoWeek(),
      startDate: prevWeekStart.toDate(),
      endDate: prevWeekEnd.toDate(),
    };
    onWeekChange(newWeek);
  };

  const handleNext = () => {
    if (!currentWeek) return;
    const nextWeekStart = moment(currentWeek.startDate).add(7, "days").startOf('isoWeek');
    const nextWeekEnd = nextWeekStart.clone().endOf('isoWeek');
    const currentWeekEnd = moment().endOf('isoWeek');
    
    // Check if next week starts after the current week ends
    if (nextWeekStart.isAfter(currentWeekEnd, 'day')) {
      return;
    }

    const newWeek = {
      year: nextWeekEnd.year(),
      week: nextWeekStart.isoWeek(),
      startDate: nextWeekStart.toDate(),
      endDate: nextWeekEnd.toDate(),
    };
    onWeekChange(newWeek);
  };

  const isNextDisabled = currentWeek && 
    moment(currentWeek.startDate).add(7, "days").startOf('isoWeek')
      .isAfter(moment().endOf('isoWeek'), 'day');

  return (
    <div className={styles.weekSelectorWrapper}>
      <button
        type="button"
        className={styles.weekArrow}
        onClick={handlePrevious}
      >
        <ArrowLeft />
      </button>

      <div className={styles.weekDateWrapper}>
        <input
          type="text"
          className={styles.weekDateInput}
          name="timesheetDatetimes"
          readOnly
          value={getFormattedDateRange()}
        />
        <CalendarIcon />
      </div>

      <button
        type="button"
        className={`${styles.weekArrow} ${isNextDisabled ? styles.disabled : ""}`}
        onClick={handleNext}
        disabled={isNextDisabled}
      >
        <ArrowRight />
      </button>
    </div>
  );
};

export default WeekSelector;
